<script setup lang="ts">
const { previewNoFade } = useGlobals()
const { shouldNavElementsBeHidden } = usePreview()
</script>

<template>
  <div
    class="nav-pill"
    :class="{
      [previewNoFade]: true,
      'fade-out': shouldNavElementsBeHidden,
    }"
  >
    <slot />
  </div>
</template>

<style lang="sass">
@import '~/assets/styles/generated/variables.sass'

// TODO: adding a backdrop filter here doesn't work with chrome, which only allows one layer
// of backdrop filters, so find another way to implement this? Or make the dropdown a
// sibling rather than a child
.nav-pill
  app-region: no-drag
  box-shadow: 0px 0px 10px 0px rgba(15, 15, 15, 0.75)
  @apply flex items-center justify-center
  @apply bg-[#{$pill-bg-default}]
  @apply outline-[#{$pill-b-outline}] outline-1
  @apply h-[#{$pill-h-default}] backdrop-blur-[#{$menu-blur-default}]
  @apply rounded-[#{$pill-btz-br-default}]
  @apply pointer-events-auto z-navigation-layer
  opacity: 1
  transition: opacity 0.35s ease-in-out
  &.fade-out
    opacity: 0.0

  &> div.pill-item + div.pill-item
    @apply -ml-1.5
</style>
